import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
// Transitional location while the centrally declared `/settings/user` layout
// remains on the file-router migration burndown.
// fallow-ignore-next-line circular-dependency -- route modules must import their parent route during the file-router migration.
import { settingsUserLayoutRoute } from 'src/routes';
import { LanguageSettingsPage } from '../../settings/user/LanguageSettingsPage';

export const Route = createRoute({
  getParentRoute: () => settingsUserLayoutRoute,
  path: '/language',
  component: LanguageSettingsPage,
  loader: () => ({
    crumb: msg('Language', { context: 'page breadcrumb' }),
  }),
});
